import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useContext, useState } from 'react'
import { PrimaryButton } from '../../../theme/buttons';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../context/AuthContext';
import { useGridPreferences } from '../../../hooks/useGridPreferences';
import { useMenuStore } from '../../../store/AuthStore';
import { useGridColumnOrderPreferencesStore, usePreferenceTypesStore } from '../../../store/Preferences/PreferencesStore';
import GenericPromises from '../../../api/GenericPromises';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';

export const CustomColumnOrder = ({ columns, setColumns, nameOrderColumns }) => {
    const [openDialogColumnOrder, setOpenDialogColumnOrder] = useState(false);
    const [openDialogReset, setOpenDialogReset] = useState(false);
    const { user } = useContext(AuthContext);
    const { findResourceIdByRoute } = useGridPreferences();
    const { getColumnOrderPreferenceByResourceId, updateColumnOrderPreference } = useGridColumnOrderPreferencesStore();
    const { getPreferenceTypeIdByPreferenceName } = usePreferenceTypesStore();
    const { GenericPostResource, GenericPutResource, GenericDeleteResource } = GenericPromises();
    const { menuState } = useMenuStore();
    const [myColumns, setMyColumns] = useState(columns);
    const [t] = useTranslation("global");
    const navigate = useNavigate();

    function handleOnDragEnd(result) {
        if (!result.destination) return;
        const items = Array.from(myColumns);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setMyColumns(items);
    }

    const ParseColumnsToPreferenceOrderValue = () => {
        let myColumnsOrder = myColumns.map((column, index) => {
            if (column.type === 'boolean') {
                return {
                    column_name: column.field,
                    column_type: 'bit',
                }
            }
            else if (column.type === 'date') {
                return {
                    column_name: column.field,
                    column_type: 'datetime',
                }
            }
            else if (column.type === 'number') {
                return {
                    column_name: column.field,
                    column_type: 'numeric',
                }
            }
            else {
                return {
                    column_name: column.field,
                    column_type: 'nvarchar',
                }
            }

        });
        return myColumnsOrder;
    }

    const SetColumnsOrderPreference = async () => {
        // get resource_id by route - validate if has id(put) if not post
        let myResourceId = findResourceIdByRoute(menuState, nameOrderColumns);
        // validate order preference get id from state
        let myPreference = getColumnOrderPreferenceByResourceId(myResourceId ?? 0);
        // get preferenceTypeId by Name
        let myPreferenceTypeId = getPreferenceTypeIdByPreferenceName("GridColumnsOrder");
        // translate preferences values to backend like PreferenceOrderValue
        let myPreferenceValue = ParseColumnsToPreferenceOrderValue();
        if (myPreference != undefined && myPreference.preference_id) {
            let myData = {
                preference_value: JSON.stringify(myPreferenceValue),
            }
            // put
            GenericPutResource(`/preferences/${myPreference.preference_id}`, myData)
                .then((responsePut) => {
                    // update state
                    let myObject = responsePut.data;
                    updateColumnOrderPreference(myObject);
                })
                .catch((error) => { throw error; });
        }
        else {
            let myData = {
                preference_value: JSON.stringify(myPreferenceValue),
                resource_id: myResourceId,
                user_company_id: user?.user_company_id,
                preference_type_id: myPreferenceTypeId,
            }
            // post
            GenericPostResource(`/preferences`, myData)
                .then((responsePost) => {
                    // update state
                    let myObject = responsePost.data;
                    updateColumnOrderPreference(myObject);
                })
                .catch((error) => { throw error; });
        }
    }

    const onSetDefaultOrderPreference = () => {
        // get resource_id by route - validate if has id(put) if not post
        let myResourceId = findResourceIdByRoute(menuState, nameOrderColumns);
        // validate order preference get id from state
        let myPreference = getColumnOrderPreferenceByResourceId(myResourceId ?? 0);
        if (myPreference && myPreference.preference_id) {
            GenericDeleteResource(`/preferences/${myPreference.preference_id}`)
                .then((responseDelete) => {
                    let myData = responseDelete.data;
                    if (myData) {
                        setMyColumns(myData.preference_value);
                        updateColumnOrderPreference(myData);
                        window.location.href = nameOrderColumns;
                    }
                })
                .catch((error) => { throw error; });
        } else {
            setOpenDialogReset(false);
            setOpenDialogColumnOrder(false);
        }
    }

    return (
        <>
            <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton onClick={() => { setOpenDialogColumnOrder(true); }}>
                    <ListItemIcon sx={{ marginInline: -1.5, marginLeft: -0.1 }}>
                        <LowPriorityIcon />
                    </ListItemIcon>
                    <ListItemText sx={{ marginBlock: -1, marginLeft: -1 }}>
                        {t("generic.grid-table.column-orders")}
                    </ListItemText>
                </ListItemButton>
            </ListItem>
            <Dialog
                open={openDialogColumnOrder}
                maxWidth={'sm'}
                fullWidth={true}
            >
                <DialogTitle>{t("generic.grid-table.column-orders")}</DialogTitle>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId={'columns'}>
                        {(provided) => (
                            <DialogContent {...provided.droppableProps} ref={provided.innerRef}>
                                {myColumns.map((column, index) => {
                                    return (
                                        <Draggable key={column.field} draggableId={column.field.toString()} index={index}>
                                            {(provided) => (
                                                <ListItemButton
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    sx={{ marginBlock: 0.2, borderRadius: 1, boxShadow: 1, backgroundColor: 'white' }}>
                                                    <DragIndicatorIcon color='action' />{column.headerName}
                                                </ListItemButton>
                                            )}
                                        </Draggable>
                                    )
                                })}
                                {provided.placeholder}
                            </DialogContent>
                        )}
                    </Droppable>
                </DragDropContext>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <PrimaryButton variant="outlined" onClick={() => { setOpenDialogReset(true); }}>
                        {t("generic.buttons.reset")}
                    </PrimaryButton>
                    <Box>
                        <Button variant='outlined' onClick={() => setOpenDialogColumnOrder(false)}>{t("generic.buttons.goback")}</Button>
                        <PrimaryButton variant="outlined" onClick={() => { setColumns(myColumns); setOpenDialogColumnOrder(false); SetColumnsOrderPreference(); }}>
                            {t("generic.buttons.accept")}
                        </PrimaryButton>
                    </Box>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogReset}
                maxWidth={'sm'}
                fullWidth={true}
            >
                <DialogTitle><InfoIcon />{t("generic.grid-table.column-orders-reset")}</DialogTitle>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setOpenDialogReset(false)}>{t("generic.buttons.goback")}</Button>
                    <PrimaryButton
                        variant="outlined"
                        onClick={() => {
                            onSetDefaultOrderPreference();
                        }}
                    >
                        {t("generic.buttons.accept")}
                    </PrimaryButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
